import React,{useContext, useState, useEffect,createContext} from 'react';
import useSWR from 'swr';
import { Router } from 'utils/with-i18next';
import http from "../services/http";


const UserDataContext = createContext();


const fetchUser = ()=> {
	return fetch('/api/users/me').then((res) => {
		if(res.status === 200){
			return res.json();
		}else{
			return null;// There is probably an error fetching the user.
		}
	}).catch(err => console.error(err))
}

export function useUser({ redirectTo = false, redirectIfFound = false } = {}){
	const userDataContext  = useContext(UserDataContext);
	
	useEffect(()=>{
	if(userDataContext && !userDataContext.userDataContextBeingInitialized){
		const user = userDataContext.user;
		if (
      			// If redirectTo is set, redirect if the user was not found.
      			(redirectTo && !redirectIfFound && !user?.email) ||
      			// If redirectIfFound is also set, redirect if the user was found
      			(redirectIfFound && user?.email)) {
			Router?.push(redirectTo);
	}
}
}, [userDataContext, redirectTo, redirectIfFound]);
	return userDataContext;
}


export function UserContextProvider({children}){


	//Initializing the state
	const [user, setUser] =  useState(null);
	const [userDataContextBeingInitialized, setUserDataContextBeingInitialized] =  useState(true);

	//Function to update the user data after fetching the user information from the backend
	const mutateUser  = (responseData)=>{setUser(responseData?.data)}

	const refreshUser = () =>{
		fetchUser().then((user) => {
			setUser(user);
			setUserDataContextBeingInitialized(false);
		})
	}

	const clearUserIfFetchingUserFails = () =>{
		return fetch('/api/users/me').then((res) => {
			if(res.status === 401){
				clearUser();
			}
		});
	}

	const clearUser = ()=>{
		setUser(null);
	}

	const isUserLoggedIn = ()=>{
		return !!user
	}

	//When the context gets created, we try to fetch the user information and save it in the context to be used accosss the app
	//until there is an 401 error that get caught which means the login access token has expired or the user has manually logged out 
	//by using the mutateUser function to clear the user data
	useEffect(() => {
		refreshUser();
		
		http.interceptors.response.use(function (response) {
			// return the response as is since all we care about is intercepting 401 status code
			return response;
		}, function (error) {
			if (error && error.response && error.response.status === 401) {
				//If a 401 error is caught this means that the access token has expired so we should the user info
				clearUserIfFetchingUserFails();
			}
			return Promise.reject(error);
		});
	}, []);


	return (
		<UserDataContext.Provider value={{userDataContextBeingInitialized, user, mutateUser, refreshUser, clearUser, isUserLoggedIn}}>
		{children}
		</UserDataContext.Provider>
		)

	}